import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_89kf2nlsjr: FaireBrandEntity = {
  token: "b_89kf2nlsjr",
  type: "brand",
  name: "Designs by Deekay Inc.",
  avatarUrl:
    "https://cdn.faire.com/fastly/7fc3e2b3ad74eeaf13607faa065c7b10aeb623df6cfae5dbf688a5ae259d7861.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/88df9be91392ac37867648ba30805d9051195929b8e6699591f9a95b42e6449c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7fc3e2b3ad74eeaf13607faa065c7b10aeb623df6cfae5dbf688a5ae259d7861.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/88df9be91392ac37867648ba30805d9051195929b8e6699591f9a95b42e6449c.jpeg",
  location: "Ontario, CA, USA",
  minimumOrderDollars: 139,
  rating: 4.8,
  reviewCount: 1519,
  isTopShop: true,
  isInsider: true,
  description:
    'Designs by Deekay Inc. was founded by Devendra Agarwal in 1993. Our company is a wholesale distributor, handling over 10,000 items and distributing to retail customers all throughout the US.  Since its initial debut, Designs by Deekay Inc. continues to gain praise for its unique and quality work. You will see the difference once you work with us. Our philosophy is to offer: "Dynamic quality products that represent incredible value, to keep our business at the cutting edge." Connect with us on social media! @SoulSticksCo on Instagram & TikTok.',
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:19.195Z",
    importedBy: "entity-db-cli",
  },
};
